<template>
  <div class="fixed inset-0 z-30 flex flex-col items-center bg-[#0a0f18] font-sans overflow-hidden">
    <canvas ref="canvasRef" class="absolute inset-0 z-0"></canvas>

    <div class="relative z-10 w-full max-w-md bg-[#f4f5f9] min-h-screen pb-20 flex flex-col shadow-2xl overflow-y-auto">
      <header class="bg-[#1e2532] text-white p-5 shadow-md sticky top-0 z-10 flex items-center">
        <button @click="$router.push('/')" class="mr-4 text-white hover:text-gray-300">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
        </button>
        <h1 class="text-lg font-extrabold">회원 정보 수정</h1>
      </header>

      <main class="p-5 flex-1">
        <form @submit.prevent="updateProfile" class="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-5">
          
          <div class="space-y-4 pb-5 border-b border-gray-100">
            <div>
              <label class="block text-xs font-bold text-gray-500 mb-1">이메일 (아이디) <span class="text-[10px] font-normal text-red-400 ml-1">변경 불가</span></label>
              <div class="w-full px-4 py-3 bg-gray-100 text-gray-500 rounded-xl text-sm font-semibold">{{ form.email }}</div>
            </div>
            <div>
              <label class="block text-xs font-bold text-gray-500 mb-1">소속 센터 <span class="text-[10px] font-normal text-red-400 ml-1">변경 불가</span></label>
              <div class="w-full px-4 py-3 bg-gray-100 text-gray-500 rounded-xl text-sm font-semibold">{{ form.center }}</div>
            </div>
          </div>

          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1">이름</label>
            <input type="text" v-model="form.name" required class="w-full px-4 py-3 bg-[#f0f4f8] border-none rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm font-bold transition-all" />
          </div>

          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1">연락처</label>
            <input type="tel" :value="form.phone" @input="formatPhone" required class="w-full px-4 py-3 bg-[#f0f4f8] border-none rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm font-bold transition-all" />
          </div>

          <div>
            <label class="block text-xs font-bold text-gray-700 mb-2">출금 계좌 정보 (수당 지급용)</label>
            <div class="flex space-x-2">
              <input type="text" v-model="form.bankName" class="w-1/3 px-3 py-3 bg-[#f0f4f8] border-none rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm font-bold text-center placeholder-gray-400" placeholder="은행명" />
              <input type="text" v-model="form.accountNumber" class="w-1/3 px-3 py-3 bg-[#f0f4f8] border-none rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm font-bold text-center placeholder-gray-400" placeholder="계좌번호" />
              <input type="text" v-model="form.accountHolder" class="w-1/3 px-3 py-3 bg-[#f0f4f8] border-none rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm font-bold text-center placeholder-gray-400" placeholder="예금주" />
            </div>
          </div>

          <button type="submit" :disabled="isSubmitting" class="w-full bg-blue-600 text-white font-bold py-3.5 rounded-xl hover:bg-blue-700 transition-colors shadow-lg mt-6 disabled:opacity-50">
            {{ isSubmitting ? '저장 중...' : '정보 수정하기' }}
          </button>
        </form>
      </main>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { auth, db } from '../../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

export default {
  setup() {
    const isSubmitting = ref(false);
    const form = reactive({ email: '', center: '', name: '', phone: '', bankName: '', accountNumber: '', accountHolder: '' });
    
    // 배경 캔버스 관련
    const canvasRef = ref(null);
    let ctx = null; 
    let animationFrameId = null; 
    const particles = []; 
    const particleCount = 60;

    const formatPhone = (e) => {
      let val = e.target.value.replace(/[^0-9]/g, '');
      if (val.length > 3 && val.length <= 7) val = val.replace(/(\d{3})(\d{1,4})/, '$1-$2');
      else if (val.length > 7) {
        if (val.startsWith('02')) val = val.replace(/(\d{2})(\d{3,4})(\d{4})/, '$1-$2-$3');
        else val = val.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
      }
      form.phone = val; e.target.value = val;
    };

    const loadProfile = async () => {
      const user = auth.currentUser; if (!user) return;
      const snap = await getDoc(doc(db, 'users', user.uid));
      if (snap.exists()) {
        const data = snap.data();
        form.email = data.email || ''; form.center = data.center || ''; form.name = data.name || ''; form.phone = data.phone || '';
        if (data.account) {
          const accParts = data.account.split('/').map(p => p.trim());
          if (accParts.length === 3) { form.bankName = accParts[0]; form.accountNumber = accParts[1]; form.accountHolder = accParts[2]; }
        }
      }
    };

    const updateProfile = async () => {
      isSubmitting.value = true;
      try {
        const user = auth.currentUser;
        let mergedAccount = '';
        if (form.bankName || form.accountNumber || form.accountHolder) mergedAccount = `${form.bankName} / ${form.accountNumber} / ${form.accountHolder}`;
        await updateDoc(doc(db, 'users', user.uid), { name: form.name, phone: form.phone, account: mergedAccount });
        alert('회원 정보가 성공적으로 수정되었습니다.');
      } catch (error) { alert('정보 수정 중 오류가 발생했습니다.'); } finally { isSubmitting.value = false; }
    };

    const initCanvas = () => {
      if (!canvasRef.value) return; ctx = canvasRef.value.getContext('2d'); resizeCanvas(); window.addEventListener('resize', resizeCanvas);
      for (let i = 0; i < particleCount; i++) { particles.push({ x: Math.random() * canvasRef.value.width, y: Math.random() * canvasRef.value.height, vx: (Math.random() - 0.5) * 0.4, vy: (Math.random() - 0.5) * 0.4, radius: Math.random() * 1.2 + 0.5 }); }
      animate();
    };
    const resizeCanvas = () => { if (!canvasRef.value) return; canvasRef.value.width = window.innerWidth; canvasRef.value.height = window.innerHeight; };
    const animate = () => {
      if (!canvasRef.value || !ctx) return; ctx.clearRect(0, 0, canvasRef.value.width, canvasRef.value.height);
      for (let i = 0; i < particles.length; i++) {
        let p = particles[i]; p.x += p.vx; p.y += p.vy; if (p.x < 0 || p.x > canvasRef.value.width) p.vx *= -1; if (p.y < 0 || p.y > canvasRef.value.height) p.vy *= -1;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2); ctx.fillStyle = 'rgba(255, 204, 0, 0.4)'; ctx.fill();
        for (let j = i + 1; j < particles.length; j++) { let p2 = particles[j]; let dx = p.x - p2.x; let dy = p.y - p2.y; let dist = Math.sqrt(dx * dx + dy * dy); if (dist < 100) { ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(p2.x, p2.y); ctx.strokeStyle = `rgba(255, 204, 0, ${0.8 - dist / 100})`; ctx.lineWidth = 0.5; ctx.stroke(); } }
      } animationFrameId = requestAnimationFrame(animate);
    };

    onMounted(() => { loadProfile(); initCanvas(); });
    onBeforeUnmount(() => { window.removeEventListener('resize', resizeCanvas); if (animationFrameId) cancelAnimationFrame(animationFrameId); });

    return { form, isSubmitting, formatPhone, updateProfile, canvasRef };
  }
}
</script>